/**
 * ontology.service.ts — Layer 3: Ontology & Knowledge Graph Domain
 */

import { getRequest, putRequest } from './http.service';
import {
  URL_GRAPHDB_PREVIEW,
  URL_ONTOLOGY,
  URL_ONTOLOGY_BY_ORG,
  URL_ONTOLOGY_BY_ORG_TYPE,
  URL_ONTOLOGY_CLASSES,
  URL_ONTOLOGY_FACTFIND,
  URL_ONTOLOGY_FACTFIND_CLIENTGRAPH,
  URL_ONTOLOGY_FACTFIND_FILL_MANUAL,
  URL_ONTOLOGY_FACTFIND_FILL_MIC,
} from './url.service';

export const fetchOntologyPreview = (type: 'ontology' | 'shacl') =>
  getRequest(URL_GRAPHDB_PREVIEW(type));

/** Fetch the global ontology TTL. Pass orgId to scope it to an org. */
export const fetchGlobalOntology = (orgId?: string | null) =>
  getRequest(orgId ? `${URL_ONTOLOGY}?org_id=${encodeURIComponent(orgId)}` : URL_ONTOLOGY);

export const fetchOrgOntology = (orgId: string) =>
  getRequest(URL_ONTOLOGY_BY_ORG(orgId));

export const saveGlobalOntology = (payload: { ttl: string; org_id?: string | null }) =>
  putRequest(URL_ONTOLOGY, payload as Record<string, unknown>);

export const saveOrgOntologyFile = (
  orgId: string,
  type: string,
  payload: { content: string; orgId: string; userId?: string },
) => putRequest(URL_ONTOLOGY_BY_ORG_TYPE(orgId, type), payload as Record<string, unknown>);

// ---------------------------------------------------------------------------
// Fact Find ontology (classes, selected fields, client graph, form fill)
// ---------------------------------------------------------------------------

export const fetchOntologyClasses = (orgId?: string | null) =>
  getRequest(orgId ? `${URL_ONTOLOGY_CLASSES}?org_id=${encodeURIComponent(orgId)}` : URL_ONTOLOGY_CLASSES);

export const fetchFactFindOntology = (orgId?: string | null) =>
  getRequest(orgId ? `${URL_ONTOLOGY_FACTFIND}?org_id=${encodeURIComponent(orgId)}` : URL_ONTOLOGY_FACTFIND);

export const fetchFactFindClientGraph = (orgId: string, clientId: string, signal?: AbortSignal) =>
  getRequest(URL_ONTOLOGY_FACTFIND_CLIENTGRAPH(orgId, clientId), signal);

/** Save the org's selected fact-find ontology classes/properties */
export const saveFactFindOntologySelection = (payload: Record<string, unknown>) =>
  putRequest(URL_ONTOLOGY_FACTFIND, payload);

export const fillFactFindFormManual = (payload: Record<string, unknown>) =>
  putRequest(URL_ONTOLOGY_FACTFIND_FILL_MANUAL, payload);

export const fillFactFindFormMicrophone = (payload: Record<string, unknown>) =>
  putRequest(URL_ONTOLOGY_FACTFIND_FILL_MIC, payload);
